import {
  buildDateTimeColumn,
  buildLinkColumn
} from '../../../../helpers/dataTable'

export const getFilesListColumn = (onClick) => [
  buildLinkColumn('File Name', 'fileName', true, { baseUrl: '/', onClick }),
  buildDateTimeColumn('Date', 'fileDate', false, { withTime: false })
]